// Defines all possible deal tabs (and their order) for the application details page.
export enum DealTab {
  Details = 'details',
  Documents = 'documents',
  Offers = 'offers',
  Approval = 'approval',
  Decisioning = 'decisioning',
  ContractRequest = 'contract-request',
  Messages = 'messages',
  Notes = 'notes',
  History = 'history',
}

// Deal tabs that are always enabled because they don’t require
// any specific conditions to be shown.
const preEnabledDealTabs = [
  DealTab.Details,
  DealTab.Documents,
  DealTab.Offers,
  DealTab.Approval,
  DealTab.History,
];

export interface ToggableDealTab {
  name: DealTab;
  isEnabled: boolean;
}

export const defaultDealTabs: ToggableDealTab[] = Object.values(DealTab).map((dealTab) => ({
  name: dealTab,
  isEnabled: preEnabledDealTabs.includes(dealTab),
}));
